import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { Edit2, Trash2 } from 'react-feather'

// Imports custom
import {
    TooltipInformation,
    CustomTableData,
    LinearLoading,
    CustomDropDown,
    TooltipApprovalInfo
} from '../../../../../../common'

export const ManagementTable = ({ useFetchInit }) => {
    
    const {
        FetchData,
        Actions
    } = useFetchInit

    const { fetchManagements } = FetchData
    const { dataManagements, loadingFetchAllManagements } = fetchManagements
    
    const { 
        handleClickFetchSpecificManagement
    } = Actions

    const columnConfig = [
        {
            //FIELD PARA TOOLTIP
            headerName: 'Info',
            maxWidth: 80,
            cellStyle: () => ({
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }),
            cellRenderer: (params) => {
                //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                const { usuario_creo, fecha_creo, usuario_modifico, fecha_modifico } = params.data
                return (
                    <TooltipInformation
                        usuario_creo={usuario_creo}
                        fecha_creo={fecha_creo}
                        usuario_modifico={usuario_modifico}
                        fecha_modifico={fecha_modifico}
                    />
                )
            }
        },
        { field: "gestion_fecha", headerName: "FECHA", minWidth: 150, filter: true },
        { field: "identificador", headerName: "ID", minWidth: 150, filter: true },
        { field: "categoria", headerName: "CATEGORIA", minWidth: 200, filter: true },
        { field: "caja", headerName: "CAJA", minWidth: 350, filter: true },
        // { field: "currency_type", headerName: "TIPO", minWidth: 150, filter: true },
        { field: "nombre_usuario", headerName: "USUARIO", minWidth: 150, filter: true },
        { field: "gestion_tipo", headerName: "GESTION", minWidth: 350, filter: true },
        // { field: "servicio", headerName: "SERVICIO", minWidth: 150, filter: true },
        // { field: "caja_destino", headerName: "DESTINO", minWidth: 150, filter: true },
        // { field: "banco", headerName: "BANCO", minWidth: 150, filter: true },
        { 
            field: "aprobacion_check",
            headerName: "APROBACION",
            minWidth: 250,
            maxWidth: 250,
            filter: true,
            cellStyle: (params) => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellClass: (params) => {

                if(params.value === 'Rechazado') return 'bg-danger';
                if(params.value === 'Aprobado') return 'bg-success';
                if(
                    ['Pendiente Aprobacion', 'Revisión de Depósito', 'Reintegro Congelado']
                        .includes(params.value)
                ) return 'bg-warning';

            },
            cellRenderer: (params) => {
                const { value } = params
                const { aprobacion_usuario, aprobacion_fecha } = params.data
                return (
                    <TooltipApprovalInfo
                        texto_approval={value}
                        usuario_approval={aprobacion_usuario}
                        fecha_approval={aprobacion_fecha}
                    />
                )
            }
        },
        {
            headerName: 'Opciones',
            minWidth: 350,
            cellRenderer: (params) => {
                const { idgestion, estado } = params.data

                return (
                    <CustomDropDown color={(estado===1)?'inherit':'error'}>
                        <MenuItem
                            onClick={() => handleClickFetchSpecificManagement(idgestion)}
                        >
                            <ListItemIcon> <Edit2 color="black"/> </ListItemIcon>
                            <ListItemText primary="Informacion" />
                        </MenuItem>
                    </CustomDropDown>
                )
            }
        }
    ]

    return (
        <div className='content'>
            {(loadingFetchAllManagements) && (<LinearLoading/>)}
            <CustomTableData 
                rowConfig={dataManagements}
                columnConfig={columnConfig}
            />
        </div>
    )
}
